/**
 * Constants for Invoice Types
 * Mirror of api/db/secondary/invoiceTypeConstants.js
 */

const INVOICE_TYPE = {
  INVOICE: 1,
  PROFORMA: 2,
};

module.exports = {
  INVOICE_TYPE,
};
